import { TransformedLayoverData } from '@/src/utils/itinerary/flightTransformers'
import { useTranslations } from 'next-intl'
import LayoverBlock from './layoverBlock'

interface LayoverBlockWrapperProps {
    layoverData: TransformedLayoverData
}

const LayoverBlockWrapper = ({ layoverData }: LayoverBlockWrapperProps) => {
    const t = useTranslations('common')
    const { layoverDuration, layoverType, cityName } = layoverData

    const formattedLayoverDuration = t('duration', {
        hours: layoverDuration.hours,
        minutes: layoverDuration.mins
    })

    const prefix = {
        layover: t('layover'),
        in: t('in')
    }

    return (
        <LayoverBlock
            prefix={prefix}
            layoverDuration={formattedLayoverDuration}
            layoverText={cityName}
            layoverType={layoverType}
        />
    )
}

export default LayoverBlockWrapper
